/**
 * Formatters
 * 
 * Utility functions for formatting data
 */

import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale/es';

/**
 * Format date to Spanish format
 */
export function formatDate(date: Date | string, formatStr: string = 'dd/MM/yyyy'): string {
  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : date;
    return format(dateObj, formatStr, { locale: es });
  } catch (error) {
    console.error('[Formatter] Error formatting date:', error);
    return '';
  }
}

/**
 * Format currency to Spanish format
 */
export function formatCurrency(amount: number, currency: string = 'EUR'): string {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency,
  }).format(amount);
}

/**
 * Format number to Spanish format
 */
export function formatNumber(number: number, decimals: number = 2): string {
  return new Intl.NumberFormat('es-ES', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(number);
}

/**
 * Format CLP (pesos chilenos) — separador de miles con punto, sin decimales.
 * Ejemplo: 24990 → "$24.990".
 */
export function formatCLP(amount: number | null | undefined): string {
  if (amount == null) return '—';
  return new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    maximumFractionDigits: 0,
  }).format(amount);
}

/**
 * Format UF — hasta 2 decimales, formato chileno.
 * Ejemplo: 1.5 → "UF 1,5".
 */
export function formatUF(amount: number | null | undefined): string {
  if (amount == null) return '—';
  return `UF ${new Intl.NumberFormat('es-CL', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  }).format(amount)}`;
}
